export default ms => new Promise(resolve => setTimeout(resolve, ms));



// WEBPACK FOOTER //
// ./src/utils/await-sleep.js